export default __webpack_public_path__ + "static/media/18.016f6409.png";